import type { ResultOf } from "gql.tada";
import { graphql } from "../../graphql";

/**
 * Query for fetching sidebar filters
 * This query is used to get filter options for filter sidebar
 */
export const GetSidebarFilters = graphql(
  `
    query getSidebarFilters($categories: [ShareVoiceSidebarCategory!]) {
      sidebarFilters(categories: $categories) {
        category
        items {
          categoryLabel
          label
        }
      }
    }
  `,
);

type SidebarFiltersResult = ResultOf<typeof GetSidebarFilters>;

/**
 * Individual dictionary item containing category label and human-readable label
 */
export type DictionaryItem =
  SidebarFiltersResult["sidebarFilters"][number]["items"][number];

/**
 * Complete sidebar filter category with its items
 */
export type SidebarFilterCategory =
  SidebarFiltersResult["sidebarFilters"][number];
